import Index from '../../pages/snail/dkhd/index';
import Query from '../../pages/snail/dkhd/query';

const base = 'dkhd';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/query*`,
    name: `${base}-query`,
    component: Query
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/dkhd.js